export default "__VITE_PUBLIC_ASSET__26be2f93__"